import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import GerarCSVFaturamento from '../pages/gestaoEnergia/gerarCSVFaturamento';
import AlterarProjeto from '../pages/gestaoEnergia/alterarProjeto';
import AjusteProjetoConsorcio from '../pages/financeiro/ajusteProjetoConsorcio';
import AtualizarProjetoGeradora from '../pages/gestaoEnergia/atualizarProjetoGeradora';
import LancamentoSPE from '../pages/financeiro/lancamentoSPE';
import RetencaoCaixaSPE from '../pages/financeiro/retencaoCaixaSPE';
import ListarDebitos from '../pages/gestaoEnergia/listarDebitos';
import ListarDistratos from '../pages/gestaoEnergia/listarDistratos';

const RouteFaturamento = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='GE'/>}>
                <Route path='gerarCSVFaturamento' element={<GerarCSVFaturamento/>}/>
                <Route path='AlterarProjeto' element={<AlterarProjeto/>}/>
                <Route path='ajusteProjetoConsorcio' element={<AjusteProjetoConsorcio/>}/>
                <Route path='atualizarProjetoGeradora' element={<AtualizarProjetoGeradora/>}/>
                <Route path='lancamentoSPE' element={<LancamentoSPE/>}/>
                <Route path='retencaoCaixaSPE' element={<RetencaoCaixaSPE/>}/>
                <Route path='listarDebitos' element={<ListarDebitos/>}/>
                <Route path='listarDistratos' element={<ListarDistratos/>}/>
            </Route>
        </Routes>
    );
};

export default RouteFaturamento;
